// Checkout waits for the latest link validation so its request includes the cookie.
let pendingCapture: Promise<void> | null = null;

export function trackReferralCapture(capture: Promise<void>) {
  const settled = capture.catch(() => undefined);
  pendingCapture = settled;
  settled.then(() => { if (pendingCapture === settled) pendingCapture = null; });
}

export async function waitForReferralCapture() {
  while (pendingCapture) await pendingCapture;
}
